import type { PreOrderFlowSuggestion } from "@stockline/shared/types/ai/pre-order-flow-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_FLOW_SUGGESTION_TABLE } from "./db"

export const preOrderFlowSuggestionConfig: OfflineResourceConfig<PreOrderFlowSuggestion> =
  {
    name: "pre-order-flow-suggestions",
    // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
    // scope change (STK-1238).
    groupScoped: true,
    endpoints: {
      full: "/api/v2/pre-order-flow-suggestions",
      delta: "/api/v2/pre-order-flow-suggestions/changes",
      push: "/api/v2/pre-order-flow-suggestions/changes",
    },
    tableName: PRE_ORDER_FLOW_SUGGESTION_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      targetId: "targetId",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
    // Tombstones stay in Dexie (pulls deliver them as upserts carrying
    // `deletedAt`); readers filter `deletedAt` themselves.
    softDelete: true,
  }
